import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import { getCustomerWithSales } from '../../api/customerApi';
import { handlePriceWithRM } from '../../utils/priceUtils';
import { convertDateTimeToDateString } from '../../utils/datetimeUtils';

export default function ViewCustomerModal({ open, customerId, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !customerId) { setData(null); return; }
    setLoading(true);
    setData(null);
    getCustomerWithSales(customerId)
      .then(res => setData(res.data))
      .catch(err => console.error('Error fetching customer:', err))
      .finally(() => setLoading(false));
  }, [open, customerId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '14px' } }}>
      <DialogTitle sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: '1.1rem' }}>Customer Details</DialogTitle>
      <DialogContent>
        {loading ? <div>Loading...</div> : data ? (
          <>
            <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }}>Contact</Typography>
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>{data.customerName}</Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#374151', fontFamily: "'Poppins', sans-serif" }}>{data.phoneNumber}</Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#374151', fontFamily: "'Poppins', sans-serif" }}>{data.email || '—'}</Typography>
              <Typography sx={{ fontSize: '0.85rem', color: '#374151', fontFamily: "'Poppins', sans-serif" }}>{data.address || '—'}</Typography>
            </Box>
            <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }}>Sales History ({data.sales?.length ?? 0})</Typography>
            {data.sales?.length > 0 ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {data.sales.map(sale => (
                  <Box key={sale.salesId} sx={{ backgroundColor: '#F8FAFC', borderRadius: '8px', padding: '10px 12px', borderLeft: '3px solid #1A8CFF' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>Sale #{sale.salesId}</Typography>
                      <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#10B981', fontFamily: "'Poppins', sans-serif" }}>{sale.finalPrice != null ? handlePriceWithRM(sale.finalPrice) : '—'}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: '0.75rem', color: '#64748B', mt: 0.5, fontFamily: "'Poppins', sans-serif" }}>
                      {sale.energy ? `${sale.energy} kWp` : ''} {sale.productCategory ?? ''} | {sale.depositOn ? convertDateTimeToDateString(sale.depositOn) : '—'} | {sale.status ?? ''}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              <Typography sx={{ fontSize: '0.85rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>No sales recorded for this customer.</Typography>
            )}
          </>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} sx={{ fontFamily: "'Poppins', sans-serif", textTransform: 'none' }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
